import React from 'react';
import SubscriptionListItem from '@components/subscription/list/SubscriptionListItem';
import { useAtomValue } from 'jotai';
import { subscriptionsAtom } from '@components/subscription/store/SubscriptionAtoms';

const SubscriptionList = () => {
  const subscriptions = useAtomValue(subscriptionsAtom);

  return (
    <div>
      {subscriptions
        .filter(item => item.expiry_date)
        .map(item => (
          <SubscriptionListItem
            subscription={item}
            key={item.subject_id}
            className={'mb-4'}
          />
        ))}
    </div>
  );
};

export default SubscriptionList;
